import axios from "axios";
import $ from "jquery";

const state = {
  reviewStatistics: {},
  newReviews: {},
  operatorReviews: { reviews: [], totalRate: null },
};

const getters = {
  reviewStatistics(state) {
    return state.reviewStatistics;
  },

  newReviews(state) {
    return state.newReviews;
  },

  operatorReviews(state) {
    return state.operatorReviews;
  },
};

const mutations = {
  setReviewStatistics(state, statistics) {
    state.reviewStatistics = statistics;
  },

  setNewReviews(state, reviews) {
    state.newReviews = reviews;
  },

  setOperatorReviews(state, reviews) {
    state.operatorReviews = reviews;
  },

  deleteNewReview(state, id) {
    let index = state.newReviews.findIndex((r) => r.id == id);
    state.newReviews.splice(index, 1);
  },

  deleteOperatorReview(state, id) {
    let index = state.operatorReviews.reviews.findIndex((r) => r.id == id);
    state.operatorReviews.reviews.splice(index, 1);
    state.operatorReviews.totalRate = state.operatorReviews.totalRate - state.operatorReviews.reviews[index].rate;
  },

  deleteReviewReply(state, id) {
    let index = state.operatorReviews.reviews.findIndex((r) => {
      if (r.reply) {
        return r.reply.id == id;
      }
      return null;
    });
    state.operatorReviews.reviews[index].reply = null;
  },
};

const actions = {
  async fetchReviewStatistics({ commit, rootState }) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;
    const user = rootState.authStore.user;
    const filter = user.role == "operator" ? `?operator=${user.id}` : "";

    await axios
      .get(`${apiUrl}/review/statistics${filter}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setReviewStatistics", res.data);
      });
  },

  async fetchNewReviews({ commit, rootState }) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/review/new`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setNewReviews", res.data);
      });
  },

  async fetchOperatorReviews({ commit, dispatch, rootState }, operator) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;
    const user = rootState.authStore.user;

    // checking if invoked from admin or operator
    if (user.role === "admin") {
      dispatch("showSpinnerLoading", null, { root: true });
    }

    await axios
      .get(`${apiUrl}/review-operator/${operator}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        if (!res.data.reviews) {
          commit("setOperatorReviews", { reviews: {}, totalRate: null });
        } else {
          commit("setOperatorReviews", res.data);
        }

        dispatch("hideSpinnerLoading", null, { root: true });
        dispatch("hideBarLoading", null, { root: true });
      });
  },

  async publishReview({ commit, dispatch, rootState }, id) {
    dispatch("showSpinnerLoading", null, { root: true });

    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .put(
        `${apiUrl}/review/publish?id=${id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then(() => {
        dispatch("hideSpinnerLoading", null, { root: true });

        $.alert("review published successfull");
        commit("deleteNewReview", id);
      });
  },

  async deleteReview({ commit, dispatch, rootState }, data) {
    dispatch("showSpinnerLoading", null, { root: true });

    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .delete(`${apiUrl}/review/delete?id=${data.id}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then(() => {
        dispatch("hideSpinnerLoading", null, { root: true });

        $.alert("review deleted successfull");

        if (data.tag === "new") {
          // delete new review
          commit("deleteNewReview", data.id);
        } else {
          // delete operator review
          commit("deleteOperatorReview", data.id);
        }
      });
  },

  async addReviewReply({ rootState }, data) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    return await axios.post(`${apiUrl}/review/reply`, data, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  },

  async operatorReviewUpdate({ rootState }, data) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    return await axios.put(`${apiUrl}/review/update/${data.id}`, data.detail, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  },

  async removeReviewReply({ commit, dispatch, rootState }, id) {
    dispatch("showSpinnerLoading", null, { root: true });

    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .delete(`${apiUrl}/review-reply/delete?id=${id}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then(() => {
        dispatch("hideSpinnerLoading", null, { root: true });

        $.alert("reply deleted successfull");

        commit("deleteReviewReply", id);
      });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
